module.exports = "/wwwroot/img/angle-down-regular.svg?ver=4e1f297b";